/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Segment,
  Header,
  Grid,
  Loader,
  Button,
  Icon,
  Form,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import { TRANSLATION_FILES } from '../../constants/translation';
import { SPA_LAWYER_REP_OPTIONS } from '../../constants/lawyerCaseStatuses';
import InputBirthdate from '../../components/InputBirthdate';

class SpaCaseDetail extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    basic: PropTypes.bool,
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    loading: PropTypes.bool,
    onUpdate: PropTypes.func,
    isProjectHimsEnabled: PropTypes.bool,
    hasActiveSecondaryLawyer: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultProps = {
    basic: false,
    canFetch: false,
  }
  constructor(props) {
    super(props);
    this.state = {
      caseData: null,
      openModal: false,
    };
  }
  componentDidMount() {
    if (this.props.data) {
      this.setCaseData(this.props.data);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setCaseData(nextProps.data);
    }
  }

  setCaseData = (d) => {
    if (d) {
      const newCaseData = {
        previous_spa_date: d.spa_date ? moment(d.spa_date) : null,
        spa_date: d.spa_date ? moment(d.spa_date) : null,
        spa_stamped_date: d.spa_stamped_date ? moment(d.spa_stamped_date) : null,
        spa_solicitor_ref_no: d.spa_solicitor_ref_no,
        repType: d.repType,
      };
      this.setState({ caseData: newCaseData });
    }
  }

  handleOnDateChange = (day, fieldname) => {
    let newCaseData = { ...this.state.caseData };
    if (newCaseData) {
      newCaseData[fieldname] = day;
    } else {
      newCaseData = { [fieldname]: day };
    }
    this.setState({ caseData: newCaseData });
  }

  handleOnInputChange = (e, { name, value }) => {
    let newCaseData = { ...this.state.caseData };
    if (newCaseData) {
      newCaseData[name] = value;
    } else {
      newCaseData = { [name]: value };
    }
    this.setState({ caseData: newCaseData });
  }

  render() {
    const { basic, data, onUpdate, loading, hasActiveSecondaryLawyer, isProjectHimsEnabled, t } = this.props;
    const { caseData, openModal } = this.state;
    const now = moment().toDate();
    const toMonth = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
    const fromMonth = new Date(2015, 0, 1);
    return (
      <Segment className="LawyerDetails" basic={basic}>
        <Grid verticalAlign="middle">
          <Grid.Column textAlign="left" width={6}>
            <Header>Details</Header>
          </Grid.Column>
          <Grid.Column textAlign="right" width={10}>
            <Button
              basic
              className="edit-spa-button"
              onClick={() => this.setState({ openModal: true })}
              size="small"
            >
              <Icon name="pencil" />Edit
            </Button>
          </Grid.Column>
        </Grid>
        {
          !loading ? (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={6}>
                SPA Date
              </Grid.Column>
              <Grid.Column textAlign="right" width={10}>
                {data && data.spa_date ? moment(data.spa_date).format('DD-MM-YYYY') : '-'}
              </Grid.Column>
            </Grid>
          ) : (
            <Segment basic padded>
              <Loader active inline="centered" />
            </Segment>
          )
        }
        {
          !loading ? (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={6}>
                SPA Stamped Date
              </Grid.Column>
              <Grid.Column textAlign="right" width={10}>
                {data && data.spa_stamped_date ? moment(data.spa_stamped_date).format('DD-MM-YYYY') : '-'}
              </Grid.Column>
            </Grid>
          ) : null
        }
        {
          !loading ? (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={6}>
                SPA Solicitor Reference No.
              </Grid.Column>
              <Grid.Column className={data && data.spa_solicitor_ref_no && data.spa_solicitor_ref_no.length > 30 && 'lawyer-wrap-text'} textAlign="right" width={10}>
                {data && data.spa_solicitor_ref_no ? data.spa_solicitor_ref_no : '-'}
              </Grid.Column>
            </Grid>
          ) : null
        }
        {
          !loading && isProjectHimsEnabled ? (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={6}>
                {t('Representation type')}
              </Grid.Column>
              <Grid.Column textAlign="right" width={10}>
                {(data && data.repType
                  ? SPA_LAWYER_REP_OPTIONS.find(opt => opt.value === data.repType).text
                  : '-') || '-'}
              </Grid.Column>
            </Grid>
          ) : null
        }
        <Modal
          open={openModal}
          onClose={() => this.setState({ openModal: false })}
          size="mini"
        >
          <Header icon="file text outline" content="Edit Details" />
          <Modal.Content>
            <Modal.Description>
              <Grid>
                <Grid.Row className="lawyer-title-pb-row">
                  <Grid.Column>SPA Date*</Grid.Column>
                </Grid.Row>
                <Grid.Row className="lawyer-input-pt-row">
                  <Grid.Column>
                    <InputBirthdate
                      date={caseData && caseData.spa_date ? caseData.spa_date.format('YYYY-MM-DD') : ''}
                      disabled={loading}
                      disabledDays={{ before: fromMonth, after: toMonth }}
                      format={null}
                      fromMonth={fromMonth}
                      monthLogic={null}
                      onSelectDay={d => this.handleOnDateChange(d, 'spa_date')}
                      showMonth={caseData && caseData.spa_date ? null : now}
                      toMonth={toMonth}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="lawyer-title-pt-row lawyer-title-pb-row">
                  <Grid.Column>SPA Stamped Date</Grid.Column>
                </Grid.Row>
                <Grid.Row className="lawyer-input-pt-row">
                  <Grid.Column>
                    <InputBirthdate
                      date={caseData && caseData.spa_stamped_date ? caseData.spa_stamped_date.format('YYYY-MM-DD') : ''}
                      disabled={loading}
                      disabledDays={{ before: fromMonth, after: toMonth }}
                      format={null}
                      fromMonth={fromMonth}
                      monthLogic={null}
                      onSelectDay={d => this.handleOnDateChange(d, 'spa_stamped_date')}
                      showMonth={caseData && caseData.spa_stamped_date ? null : now}
                      toMonth={toMonth}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="lawyer-title-pt-row">
                  <Grid.Column>
                    <Form className="lawyer-confirmation-form-input">
                      <Form.Input
                        fluid
                        name="spa_solicitor_ref_no"
                        label="SPA Solicitor Reference No"
                        value={caseData ? caseData.spa_solicitor_ref_no : ''}
                        onChange={this.handleOnInputChange}
                      />
                    </Form>
                  </Grid.Column>
                </Grid.Row>
                { isProjectHimsEnabled && (
                  <Grid.Row className="lawyer-title-pt-row">
                    <Grid.Column>
                      <Form className="lawyer-confirmation-form-input">
                        <Form.Select
                          label="Lawyer represents (in e-SPA)*"
                          name="repType"
                          validateLabel="Lawyer represents (in e-SPA)"
                          options={SPA_LAWYER_REP_OPTIONS}
                          value={caseData ? caseData.repType : ''}
                          onChange={this.handleOnInputChange}
                          disabled={!hasActiveSecondaryLawyer}
                        />
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                )}
              </Grid>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button negative onClick={() => this.setState({ openModal: false })} icon="cancel" content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
            <Button
              positive
              onClick={(e) => {
                this.setState({ openModal: false });
                onUpdate(e, caseData);
              }}
              icon="checkmark"
              content={t('Save', { ns: TRANSLATION_FILES.translation })}
            />
          </Modal.Actions>
        </Modal>
      </Segment>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(SpaCaseDetail);



// WEBPACK FOOTER //
// ./src/containers/Lawyer/SpaCaseDetail.jsx